import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Partner } from '../_models/partner';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PartnersService {
  public updatePartnerData = new BehaviorSubject<Partner>(null);

  constructor(private http: HttpClient) {}

  getAllPartners() {
    return this.http.get<Partner[]>(`${environment.apiUrl}/api/partners`).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  deletePartner(partnerId: number) {
    return this.http.delete(`${environment.apiUrl}/api/partners/${partnerId}`);
  }

  updatePartner(partnerId: number, partner: Partner) {
    return this.http.patch<Partner>(
      `${environment.apiUrl}/api/partners/${partnerId}`,
      partner
    );
  }

  addPartner(partner: Partner) {
    return this.http.post<Partner>(
      `${environment.apiUrl}/api/partners`,
      partner
    );
  }

  /**
   * IMPROVED
   */

  getAll(pageIndex: number, perPage: number, queryParams) {
    return this.http.get<any>(
      `${environment.apiUrl}/api/partners?page=${pageIndex}&per_page=${perPage}&${queryParams}`
    );
  }

  delete(partnerId: number) {
    return this.http.delete(`${environment.apiUrl}/api/partners/${partnerId}`);
  }

  getOne(partnerId: number) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/partners/${partnerId}`
    );
  }
}
